import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import SchedulingCard from 'shared/components/Cards/scheduling_card';
import flow from 'lodash/flow';
var dateFormat = require('dateformat');

const style = {
	border: '1px dashed red',
	padding: '0.5rem 1rem',
	margin: '.5rem',
	backgroundColor: 'white',
	cursor: 'move'
};

class Card extends Component {

	render() {

		const { card,id,isDragging, connectDragSource, connectDropTarget,users,toggle,status_code,is_charged,periodical_name,freq,date,facility_name} = this.props;
		const opacity = isDragging ? 0 : 1;
		const monthYear = date ? dateFormat(date, "mmm yyyy") : '';

		return connectDragSource(
			<div>
					<SchedulingCard id={id} status_code={status_code}  is_charged={is_charged} toggle={toggle} periodical_name={periodical_name} freq={freq}
					date={dateFormat(date,"dd-mmm")}
					month_year={monthYear}
					users={users} facility_name={facility_name}/>
			</div>
				);
	}
}

const cardSource = {

	canDrag(props) {

		if(props.card.status==1||props.card.status==2){
			return true
		}
		else{
			return false
		}
	  },
	  
	beginDrag(props) {		
		
			return {			
				index: props.index,
				listId: props.listId,
				card: props.card
			};
	},

	endDrag(props, monitor) {
		
		const item = monitor.getItem();
		const dropResult = monitor.getDropResult();	

		if ( dropResult && dropResult.listId !== item.listId ) {
			props.removeCard(item.index);
		}
	}
};

const cardTarget = {

	hover(props, monitor, component) {
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;
		const sourceListId = monitor.getItem().listId;	

		// Don't replace items with themselves
		if (dragIndex === hoverIndex) {
			return;
		}

		// Determine rectangle on screen
		const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

		// Get vertical middle
		const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

		// Determine mouse position
		const clientOffset = monitor.getClientOffset();

		// Get pixels to the top
		const hoverClientY = clientOffset.y - hoverBoundingRect.top;

		// Only perform the move when the mouse has crossed half of the items height
		// When dragging downwards, only move when the cursor is below 50%
		// When dragging upwards, only move when the cursor is above 50%

		// Dragging downwards
		if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
			return;
		}

		// Dragging upwards
		if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
			return;
		}

		// Time to actually perform the action
		if ( props.listId === sourceListId ) {
			//console.log("move request");
			props.moveCard(dragIndex, hoverIndex);

			// Note: we're mutating the monitor item here!
			// Generally it's better to avoid mutations,
			// but it's good here for the sake of performance
			// to avoid expensive index searches.
			monitor.getItem().index = hoverIndex;
		}		
	}
};

export default flow(
	DropTarget("CARD", cardTarget, connect => ({
		connectDropTarget: connect.dropTarget()
	})),
	DragSource("CARD", cardSource, (connect, monitor) => ({
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	}))
)(Card);


// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalScheduling/card.js